import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { AppRoutingModule } from './/app-routing.module';

import { StockService } from './services/stock.service';
import { ReservationService } from './services/reservation.service';
import { OrderService } from './services/order.service';

import {EventHttpInterceptor } from './interceptors/eventHttp.interceptor';
import { LoginComponent } from './pages/login/login.component';

import { AuthGuard } from './guards/auth.guard';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    LayoutModule,
    AppRoutingModule,
    CommonModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    StockService,
    ReservationService,
    OrderService,
    {provide: HTTP_INTERCEPTORS, useClass: EventHttpInterceptor, multi: true},
    AuthGuard
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/app.module.ts